import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav');
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-nav',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav/view.scss */
/* src/app/component.nav/view.scss: no such file or directory */`],
})
export class ComponentNavComponent implements OnInit {
    public currentDate = '';
    public currentTime = '';
    private timer: any;

    public mode = "main";
    public url = '';

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef,@Inject( Router    )         public router: Router    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.url = this.router.url;
        if (!this.url.includes('main')) this.mode = "page";
        await this.updateTime();
        this.timer = setInterval(() => {
            this.updateTime();
            this.cdr.detectChanges();
        }, 1000);
    }

    public async ngOnDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    public async updateTime() {

        const now = new Date();

        this.currentDate = now.toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            weekday: "long",
        });

        const hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const seconds = now.getSeconds().toString().padStart(2, "0");
        const ampm = hours < 12 ? "AM" : "PM";
        const formattedHours = (hours % 12 === 0 ? 12 : hours % 12)
            .toString()
            .padStart(2, "0");

        this.currentTime = `${ampm} ${formattedHours}:${minutes}:${seconds}`;
    }
}

export default ComponentNavComponent;